import api from "../api";

export const isVitecProject = (entity: { integrations?: api.ProjectIntegrationData | api.CustomerIntegrationData }) =>
  Boolean(entity.integrations?.vitec_data);
